import React from 'react';
import {
    Edit,
    Create,
    List,
    Datagrid,
    SimpleForm,
    EditButton,
    TextField,
    NumberField,
    ArrayField,
    ReferenceField,
    // ReferenceManyField,
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    BooleanInput,
    TextInput,
    NumberInput,
    // ArrayInput,
    SelectInput,
    SelectArrayInput,
    // CheckboxGroupInput,
    ReferenceInput,
    ReferenceArrayInput,
    Pagination,
    BooleanField
} from 'react-admin';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

const width100 = {
    width: "100%"
}
const ofPointsInput = {
    margin: "1em"
}
const halfWithMargin = {
    margin: "1em",
    width: "45%"
}
const fullWithMargin = {
    margin: "1em",
    width: "95%"
}

export const HEXSelectorSegmentCollectionList = (props) => (
    <List title="Segment Collection" pagination={<Pagination rowsPerPageOptions={[10,50,100,250,500]} />} {...props}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField source="name"></TextField>
            <ReferenceArrayField label="Segments" source="segmentIds" reference="HEXSelector/Segments" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="description" />
                </SingleFieldList>
            </ReferenceArrayField>
            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorSegmentCollectionEdit = (props) => (
    <Edit {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <ReferenceArrayInput label="Segments" source="segmentIds"  reference="HEXSelector/Segments" perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const HEXSelectorSegmentCollectionCreate = (props) => (
    <Create {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <ReferenceArrayInput label="Segments" source="segmentIds"  reference="HEXSelector/Segments" perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);

export const HEXSelectorSegmentList = (props) => (
    <List {...props} pagination={<Pagination rowsPerPageOptions={[10,50,100, 250, 500]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField Label="Name" source="name"></TextField>
            <ReferenceArrayField label="Applications" source="applicationIds" reference="HEXSelector/Applications" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="description"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>
            <ReferenceArrayField label="Used In Licenses" source="segmentCollectionIds" reference="HEXSelector/SegmentCollections" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>
            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorSegmentEdit = (props) => (
    <Edit {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <ReferenceArrayInput label="Applications" source="applicationIds" reference="HEXSelector/Applications" perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List" source="fluidRuleId" reference="HEXSelector/SegFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const HEXSelectorSegmentCreate = (props) => (
    <Create {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <ReferenceArrayInput label="Applications" source="applicationIds" reference="HEXSelector/Applications" perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List" source="fluidRuleId" reference="HEXSelector/SegFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Create>
);
    
export const HEXSelectorApplicationList = (props) => (
    <List {...props} pagination={<Pagination rowsPerPageOptions={[10,50,100,250,500]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }} >
            <TextField source="name"></TextField>
            <ReferenceArrayField label="Products: Name (Pandora Config, Markup)" source="productIds" reference="HEXSelector/Products" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="description"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>
            <ReferenceArrayField label="Used In Segments" source="segmentIds" reference="HEXSelector/Segments" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>

            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorApplicationEdit = (props) => (
    <Edit {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <NumberInput label="Sort Order" source="sortOrder"></NumberInput>
            <ReferenceArrayInput label="Products" source="productIds" reference="HEXSelector/Products" style={width100} perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List Side 1" source="fluidRuleSide1Id" reference="HEXSelector/AppFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="Fluid List Side 2" source="fluidRuleSide2Id" reference="HEXSelector/AppFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);
export const HEXSelectorApplicationCreate = (props) => (
    <Create {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name"></TextInput>
            <NumberInput label="Sort Order" source="sortOrder"></NumberInput>
            <ReferenceArrayInput label="Products" source="productIds" reference="HEXSelector/Products" style={width100} perPage={1000}>
                <SelectArrayInput optionText="description"></SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List Side 1" source="fluidRuleSide1Id" reference="HEXSelector/AppFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="Fluid List Side 2" source="fluidRuleSide2Id" reference="HEXSelector/AppFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export const HEXSelectorProductList = (props) => (
    <List title="Products" {...props} pagination={<Pagination rowsPerPageOptions={[10,50,100, 250,500]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField label="Name" source="name"></TextField>
            <TextField label="Description" source="description"></TextField>
            <ReferenceField label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" >
                <ChipField source="type"></ChipField>
            </ReferenceField>    
            <NumberField label="Markup" source="markup"></NumberField>
            {/* <ArrayField source="dutyTypes">
                <SingleFieldList>
                    <ChipField source="name"></ChipField>
                </SingleFieldList>
            </ArrayField> */}
            <ReferenceField label="Pandora Config" source="pandoraId" reference="HEXSelector/PandoraConfigs" perPage={1000}>
                <ChipField source="description"></ChipField>
            </ReferenceField>
            <ReferenceArrayField label="Used In Applications" source="applicationIds" reference="HEXSelector/Applications" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>
            <BooleanField label="Multi Section" source="allowMultiSection" ></BooleanField>
            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorProductEdit = (props) => (
    <Edit {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name" />
            <ReferenceInput label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" >
                <SelectInput optionText="type"></SelectInput>
            </ReferenceInput>
            <NumberInput label="Markup" source="markup" />
            <BooleanInput label="Multi Section" source="allowMultiSection" ></BooleanInput>
            <ReferenceInput label="Pandora Config" source="pandoraId" reference="HEXSelector/PandoraConfigs" perPage={1000}>
                <SelectInput optionText="description"></SelectInput>
            </ReferenceInput>
            <ReferenceArrayInput label="Duty Types" source="dutyType_ids" reference="HEXSelector/DutyTypes" >
                <SelectArrayInput>
                    <ChipField source="name"></ChipField>
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List Side 1" source="fluidRuleSide1Id" reference="HEXSelector/ProdFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="Fluid List Side 2" source="fluidRuleSide2Id" reference="HEXSelector/ProdFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);
export const HEXSelectorProductCreate = (props) => (
    <Create {...props}>
        <SimpleForm style={width100}>
            <TextInput label="Name" source="name" />
            <ReferenceInput label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" >
                <SelectInput optionText="type"></SelectInput>
            </ReferenceInput>
            <NumberInput label="Markup" source="markup" />
            <BooleanInput label="Multi Section" source="allowMultiSection" ></BooleanInput>
            <ReferenceInput label="Pandora Config" source="pandoraId" reference="HEXSelector/PandoraConfigs" perPage={1000}>
                <SelectInput optionText="description"></SelectInput>
            </ReferenceInput>
            <ReferenceArrayInput label="Duty Types" source="dutyType_ids" reference="HEXSelector/DutyTypes" >
                <SelectArrayInput>
                    <ChipField source="name"></ChipField>
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceInput label="Fluid List Side 1" source="fluidRuleSide1Id" reference="HEXSelector/ProdFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="Fluid List Side 2" source="fluidRuleSide2Id" reference="HEXSelector/ProdFluidRules" perPage={1000}>
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
        </SimpleForm>
    </Create>
);


export const HEXSelectorPandoraConfigList = (props) => (
    <List title="Pandora Configurations" {...props} pagination={<Pagination rowsPerPageOptions={[10,50,100,250,500]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField label="Internal Name" source="internalName"></TextField>
            <ReferenceField label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" >
                <ChipField source="type"></ChipField>
            </ReferenceField>    
            <ReferenceArrayField label="Used In Products" source="usedInProducts" reference="HEXSelector/Products" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name"></ChipField>
                </SingleFieldList>
            </ReferenceArrayField>
            <ArrayField label="Used in Segment Collections" source="info">
                <SingleFieldList>
                    <ChipField source="text"></ChipField>
                </SingleFieldList>
            </ArrayField>
            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorPandoraConfigCreate = (props) => (
    <Create {...props}>
    <SimpleForm style={{width:"100%"}}>
        <Paper>
            <TextInput source="internalName" style={halfWithMargin} />
            <ReferenceInput label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" style={halfWithMargin} >
                <SelectInput optionText="type"></SelectInput>
            </ReferenceInput>
        </Paper>
        <Paper style={halfWithMargin}>
            <h2 style={fullWithMargin}>Delta Pressure OF (values in %)</h2>
            <Divider />
            <NumberInput label="DP 3 kPa (%)" source="dp3" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 5 kPa (%)" source="dp5" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 10 kPa (%)" source="dp10" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 15 kPa (%)" source="dp15" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 20 kPa (%)" source="dp20" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 30 kPa (%)" source="dp30" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 40 kPa (%)" source="dp40" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 50 kPa (%)" source="dp50" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 75 kPa (%)" source="dp75" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 100 kPa (%)" source="dp100" style={ofPointsInput}></NumberInput>
        </Paper>
        <Paper style={{width:"50%", padding:"1em"}}>
            <h2 style={fullWithMargin}>Load OF based on NTU (values in %)</h2>
            <Divider />
            <NumberInput label="Load OF at NTU 0 (%)" source="ntu0" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 0.5 (%)" source="ntu05" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 1 (%)" source="ntu1" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 2 (%)" source="ntu2" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 3 (%)" source="ntu3" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 4 (%)" source="ntu4" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 5 (%)" source="ntu5" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 6 (%)" source="ntu6" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 7 (%)" source="ntu7" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 8 (%)" source="ntu8" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 9 (%)" source="ntu9" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 10 (%)" source="ntu10" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 11 (%)" source="ntu11" style={ofPointsInput}></NumberInput>
        </Paper>
    </SimpleForm>
</Create>
);

export const HEXSelectorPandoraConfigEdit = (props) => (
<Edit {...props}>
    <SimpleForm style={{width:"100%"}}>
        <Paper style={{width:"50%", padding:"1em"}}>
            <TextInput source="internalName" style={halfWithMargin} />
            <ReferenceInput label="Type" source="typeId" reference="HEXSelector/ExchangerTypes" style={halfWithMargin} >
                <SelectInput optionText="type"></SelectInput>
            </ReferenceInput>
        </Paper>
        <Paper style={{width:"50%", padding:"1em"}}>
            <h3 style={fullWithMargin}>Delta Pressure OF (values in %)</h3>
            <Divider />
            <NumberInput label="DP 3 kPa (%)" source="dp3" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 5 kPa (%)" source="dp5" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 10 kPa (%)" source="dp10" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 15 kPa (%)" source="dp15" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 20 kPa (%)" source="dp20" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 30 kPa (%)" source="dp30" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 40 kPa (%)" source="dp40" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 50 kPa (%)" source="dp50" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 75 kPa (%)" source="dp75" style={ofPointsInput}></NumberInput>
            <NumberInput label="DP 100 kPa (%)" source="dp100" style={ofPointsInput}></NumberInput>
        </Paper>
        <Paper style={{width:"50%", padding:"1em"}}>
            <h3 style={fullWithMargin}>Load OF based on NTU (values in %)</h3>
            <Divider />
            <NumberInput label="Load OF at NTU 0 (%)" source="ntu0" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 0.5 (%)" source="ntu05" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 1 (%)" source="ntu1" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 2 (%)" source="ntu2" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 3 (%)" source="ntu3" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 4 (%)" source="ntu4" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 5 (%)" source="ntu5" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 6 (%)" source="ntu6" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 7 (%)" source="ntu7" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 8 (%)" source="ntu8" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 9 (%)" source="ntu9" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 10 (%)" source="ntu10" style={ofPointsInput}></NumberInput>
            <NumberInput label="Load OF at NTU 11 (%)" source="ntu11" style={ofPointsInput}></NumberInput>
        </Paper>
    </SimpleForm>
</Edit>
);